import { render, staticRenderFns } from "./nodeView.vue?vue&type=template&id=6871eb2c&scoped=true&lang=html"
import script from "./nodeView.vue?vue&type=script&lang=js"
export * from "./nodeView.vue?vue&type=script&lang=js"
import style0 from "./nodeView.vue?vue&type=style&index=0&id=6871eb2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6871eb2c",
  null
  
)

export default component.exports